import { Modalator } from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class PersonalDataBtn extends HTMLAnchorElement {
    connectedCallback() {
        this.addEventListener('click', (e) => {
            e.preventDefault();

            const url = this.dataset.href;
            const modal = new Modalator();

            modal.initRemoteModal('#modal-edit-my-personal-data', url, null, (data) => {
                if (data) {
                    if (data.name) {
                        document.querySelector('.js-name').innerText = data.name;
                    }
                    if (data.civility) {
                        document.querySelector('.js-civility').innerText = data.civility;
                    }
                    if (data.phone) {
                        document.querySelector('.js-phone').innerText = data.phone;
                    }
                    if (data.mobile) {
                        document.querySelector('.js-mobile').innerText = data.mobile;
                    }
                }
                toastr.success('Enregistrement effectué');
            }, () => {
                // Met à jour la présentation des alertes
                setTimeout(() => {
                    const alertBlock = document.querySelector('.alert-block');
                    if (alertBlock) {
                        alertBlock.classList.add('m-5');
                    }
                    const alertBlockCloseBtn = document.querySelector('.alert-block>button');
                    if (alertBlockCloseBtn) {
                        alertBlockCloseBtn.classList.add('btn-close');
                        alertBlockCloseBtn.innerHTML = '';
                        alertBlockCloseBtn.addEventListener('click', () => {
                            alertBlock.remove();
                        });
                    }
                }, 100);
            });
        });
    }
}
